import { Routes } from '@angular/router';

export const uaaModuleRoutes: Routes = [
  { path: '', redirectTo: 'users', pathMatch: 'full' },
  {
    path: 'users',
    loadComponent: () => import('./uaa-users/uaa-users').then((m) => m.UaaUsers),
    data: {
      name: 'Users',
    },
  },
  {
    path: 'roles',
    loadComponent: () => import('./uaa-roles/uaa-roles').then((m) => m.UaaRoles),
    data: {
      name: 'Roles',
    },
  },
  {
    path: 'role-permissions/:id',
    loadComponent: () =>
      import('./uaa-roles/role-permissions/role-permissions').then((m) => m.RolePermissions),
    data: {
      name: 'Role Permissions',
      isNotAMenuItem: true,
    },
  },
];
